import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLeaf32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconLeaf32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m12 18.572-1.413 1.412a6.5 6.5 0 0 1 .653-8.43c.533-.534 1.48-1.085 2.803-1.566 1.288-.469 2.779-.816 4.242-1.03 1.465-.215 2.837-.288 3.879-.238.42.02.753.058.998.104.046.244.084.577.104.998.05 1.042-.023 2.413-.238 3.879-.214 1.463-.561 2.954-1.03 4.242-.481 1.322-1.032 2.27-1.565 2.802a6.5 6.5 0 0 1-8.431.653L13.4 20H18a1 1 0 1 0 0-2h-2.6l3.57-3.569a1 1 0 1 0-1.415-1.414L14 16.572V14.5a1 1 0 0 0-2 0zm-2.174-8.433A8.5 8.5 0 0 0 9.16 21.41l-2.15 2.15a1 1 0 1 0 1.415 1.415l2.15-2.15a8.5 8.5 0 0 0 11.272-.666c3.32-3.32 4.164-13.514 2.828-14.85-1.335-1.335-11.53-.49-14.849 2.829m13.25-1.659-.006-.012z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLeaf32);
